/* Lotus Wheel body-zones card — reveals on scroll: the silhouette fades in,
   markers pop one-by-one, labels stagger up. Progressive enhancement
   (final state already correct without JS); skipped for reduced motion. */
class ZonesReveal extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.classList.add('is-armed');
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          this.classList.add('is-revealed');
          this.observer.disconnect();
        }
      },
      { threshold: 0.25 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

customElements.define('zones-reveal', ZonesReveal);
